@let disabled = $disabled(); @let operatorStack = $operatorStack();
@for (operator of $operators(); track operator.trackId; let i = $index) {
    <div>
        <cm-operator-list-item
            [disabled]="disabled"
            [isInactive]="i > $selectedOperatorIndex()"
            [operator]="operator"
            (selectOperatorClick)="selectOperator($event)"
            (lockOperatorClick)="lockOperator($event)"
            (enableOperatorClick)="enableOperator($event)"
            (duplicateOperatorClick)="duplicateOperator($event)"
            (deleteOperatorClick)="deleteOperator($event)"
        ></cm-operator-list-item>
    </div>
}
@if (!disabled) {
    @if ($canAddAutoTiling()) {
        <div class="cm-add-tiling-wrapper" matTooltip="Add Tiling">
            <cm-list-item (click)="addOperator('operator-tiling')">
                <ng-container cm-pre-title>
                    <i class="far fa-plus"></i>
                </ng-container>
                <ng-container cm-title> Add Tiling</ng-container>
            </cm-list-item>
            <button type="button" [matMenuTriggerFor]="operatorMenu" (click)="$event.stopPropagation()" class="cm-tiling-menu-trigger">
                <i class="fas fa-ellipsis-v"></i>
            </button>
        </div>
    } @else {
        <div [matTooltip]="$canAddOperator() ? 'Add operator' : 'Unable to add $operators() until AutoTiling has completed.'">
            <cm-list-item [class.cm-disabled]="!$canAddOperator()" [matMenuTriggerFor]="operatorMenu">
                <ng-container cm-pre-title>
                    <i class="far fa-plus"></i>
                </ng-container>
                <ng-container cm-title> Add operator</ng-container>
            </cm-list-item>
        </div>
    }
    <mat-menu #operatorMenu="matMenu" yPosition="below">
        @for (item of $operatorDescByType() | keyvalue; track item.key) {
            @if (item.value && isOperatorTypeAllowed(item.value.type)) {
                <button mat-menu-item (click)="addOperator(item.value.type)">
                    {{ item.value.label }}
                </button>
            }
        }
    </mat-menu>
}

<ng-content select="[cm-extra-content]"></ng-content>

@if ($isDebugEnabled()) {
    <cm-button (click)="importOperators.emit()">
        <ng-container cm-left-icon>
            <i class="far fa-copy"></i>
        </ng-container>
        <ng-container cm-text>Copy operators from revision</ng-container>
    </cm-button>
    <!-- TODO to be removed -->
    <cm-button (click)="forceFullRedraw()">
        <ng-container cm-left-icon>
            <i class="far fa-broom-wide"></i>
        </ng-container>
        <ng-container cm-text>Force full redraw</ng-container>
    </cm-button>
    @if ($canRegenerateSourceThumbnails()) {
        <cm-button (click)="regenerateSourceThumbnails()">
            <ng-container cm-text>Regenerate source thumbnails</ng-container>
        </cm-button>
    }
}
@if (operatorStack.isDebugEnabled) {
    <cm-inspector-section>
        <ng-container cm-title>Cache</ng-container>
        <ng-container cm-content>
            <div>
                <!--                <span class="cm-label">Max physical cache size (GB)</span>-->
                <!--                <cm-slider [min]="1" [max]="64" [exponent]="4" [displayValuePrecision]="2" [(value)]="maxCacheSizeGB"></cm-slider>-->
                @if ($physicalCacheStats(); as stats) {
                    <cm-hint>
                        <ng-container cm-text>
                            Physical image cache stats:<br />
                            {{ stats.content }}<br />
                            {{ stats.mem }}
                        </ng-container>
                    </cm-hint>
                }
                @if ($virtualCacheStats(); as stats) {
                    <cm-hint>
                        <ng-container cm-text>
                            Virtual image cache stats:<br />
                            {{ stats.content }}<br />
                            {{ stats.mem }}<br />
                            @for (atlas of stats.atlases; track $index) {
                                Atlas {{ $index }}: {{ atlas }}<br />
                            }
                        </ng-container>
                    </cm-hint>
                }
            </div>
            <div>
                <span class="cm-label">Min mip-level</span>
                <cm-slider
                    [min]="0"
                    [max]="MAX_MIP_LEVELS - 1"
                    [step]="1"
                    [displayValuePrecision]="0"
                    [value]="$minMipLevel()"
                    (valueChange)="setMinMipLevel($event)"
                ></cm-slider>
            </div>
            <button (click)="ImageOpNode.printDebugInfo()">List image-op-nodes</button>
            <button (click)="ImageOpHal.printDebugInfo()">List virtual image allocations</button>
            <button (click)="ImageOpHal.checkNoLockedPages()">Check for locked pages</button>
            <button (click)="ImageOpHal.freeAllPages()">Free all virtual image pages</button>
            <button (click)="listImages(true)">List allocated images</button>
            <button (click)="listImages(false)">List all images</button>
            <button (click)="freeAllUnusedImages()">Free all unused images</button>
            <button (click)="requestRedraw()">Request redraw</button>
            <button (click)="exportNodeGraph()">Export image-op graph</button>
            <cm-toggle [(toggle)]="WebGl2Settings.FrequentGlErrorChecking">
                <ng-container cm-text><span>Frequent GL error checking</span></ng-container>
            </cm-toggle>
            <cm-toggle [(toggle)]="TextureEditorSettings.EnableFullTrace">
                <ng-container cm-text><span>Full trace</span></ng-container>
            </cm-toggle>
            <cm-toggle [(toggle)]="TextureEditorSettings.EnableAllocTrace">
                <ng-container cm-text><span>Alloc trace</span></ng-container>
            </cm-toggle>
            <cm-toggle [(toggle)]="TextureEditorSettings.ShowTiles">
                <ng-container cm-text><span>Show tiles</span></ng-container>
            </cm-toggle>
            <cm-toggle [(toggle)]="operatorStack.tilingCanvas.showAtlas">
                <ng-container cm-text><span>Show atlas</span></ng-container>
            </cm-toggle>
            <cm-toggle [toggle]="$enableIntegrityChecks()" (toggleChange)="setEnableIntegrityChecks($event)">
                <ng-container cm-text><span>Check integrity</span></ng-container>
            </cm-toggle>
            <div>
                <span class="cm-label">PixelSize</span>
                <cm-slider [min]="1" [max]="16" [displayValuePrecision]="0" [value]="$pixelSize()" (valueChange)="setPixelSize($event)"></cm-slider>
            </div>
        </ng-container>
    </cm-inspector-section>
}
